module.exports = __webpack_public_path__ + "img/wifi.261350ec.svg";